// import { useEffect, useState } from "react";
// import axios from "axios";
// import SummaryApi from "../../common/SummaryApi";
// import OfferCard from "../HomeComponents/OfferCard";

// const OfferPage = ({ category }) => {
//   const [offers, setOffers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchOfferProducts = async () => {
//       try {
//         setLoading(true);

//         const res = await axios({
//           url: SummaryApi.fetchOfferProducts.url(category),
//           method: SummaryApi.fetchOfferProducts.method,
//         });
// console.log(res.data);

//         if (res.data?.success) {
//           setOffers(res.data.products || []);
//         } else {
//           setOffers([]);
//         }
//       } catch (err) {
//         console.error("New arrivals fetch error", err);
//         setOffers([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOfferProducts();
//   }, [category]);

//   return (
//     <section className="w-full bg-white py-6 sm:py-10">
//       <div className="max-w-7xl mx-auto px-4">
//         {loading ? (
//           <p className="text-center text-gray-500">Loading offers...</p>
//         ) : (
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
//             {offers.map((item) => (
//               <OfferCard
//                 key={item.id}
//                 image={item.image}
//                 title={item.title}
//                 subtitle={item.subtitle}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//       {/* <OfferPage category="women" />
// <OfferPage category="men" />
// <OfferPage category="kids" />
// <OfferPage category="others" /> */}

//     </section>
//   );
// };

// export default OfferPage;


import { useEffect, useState } from "react";
import axios from "axios";
import SummaryApi from "../../common/SummaryApi";
import OfferCard from "../HomeComponents/OfferCard";

const OfferPage = ({ category }) => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOfferProducts = async () => {
      try {
        setLoading(true);

        const res = await axios({
          url: SummaryApi.fetchOfferProducts.url(category),
          method: SummaryApi.fetchOfferProducts.method,
        });

        if (res.data?.success) {
          setOffers(res.data.products || []);
        } else {
          setOffers([]);
        }
      } catch (err) {
        console.error("New arrivals fetch error", err);
        setOffers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOfferProducts();
  }, [category]);

  return (
    <section className="w-full bg-white py-6 sm:py-10">
      <div className="max-w-7xl mx-auto px-4">
        {loading ? (
          <p className="text-center text-gray-500">Loading offers...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {offers.slice(0, 4).map((item) => (
              <OfferCard
                key={item._id}
                image={item.image}
                title={item.brand}
                subtitle={item.discount}
                productId={item._id}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default OfferPage;
